<template>
    <div class="cloudLabDetail_wrap">
        <el-page-header @back="$core.goBack"></el-page-header>
        <!-- 轮播图 -->
        <div  class="banner_wrap banner_wrap_one"  v-if="modelId == 1">
            <div class="banner_title"><span>数据科学实验系统</span></div>
            <div class="banner_text">
                数据科学知识的一站式学习平台，从Python和R语言的基础语法开始，逐步延伸到深层面的数据分析方法教学，独特的理论与案例相结合的教学方式可大程度地提升学习效率。
            </div>
        </div>
        <div class="banner_wrap banner_wrap_two"  v-else>
            <div class="banner_title"><span>人工智能实训系统</span></div>
            <div class="banner_text">
               Python是集统计分析与图形显示于一体的计算机编程语言。本平台从语言基础和算法模型教学，逐渐深入到自然语言处理、机器视觉等，建立起─套完整的人工智能实训课程。
            </div>
        </div>
        <!-- 预留位置 -->
        <div class="flex-between last_read">
            <div></div>
        </div>
        <el-row>
            <!-- 左侧导航栏 -->
            <el-col :span="5">
                <div class="aside_wrap">
                    <div class="jupyter_icon" @click="startLab">
                        <i class="iconfont icon-jupyter"></i>
                        <div>开启实验环境</div>
                    </div>
                    <el-menu  mode="vertical" :collapse='true'>
                        <el-submenu  :index="nav.title" v-for="nav in navList" :key="nav.title">
                            <template slot="title">
                                <i :class="[nav.menuIcon,'iconfont']">&nbsp;{{nav.title}}</i>
                            </template>
                            <el-menu-item @click="goAnchor(item.idName)"  v-for="item in nav.courses" :key="item.id">{{item.title}}</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
            </el-col>
            <!-- 右侧内容,空白显示 -->
            <el-col :span="19">
                <div class="model_wrap" id="box">
                    <div class="model_wrap_item" v-for="item in modelContent" :key="item.id">
                        <div class="flex-center model_title">
                            <div class="flex-center" :id="item.idName">
                                <el-divider direction="vertical"></el-divider>
                                <div>{{item.title}}</div>
                            </div>
                            <div class="stage_button_wrap flex-start" v-if="Boolean(item.levels.length)">
                                <div :class="['stage_button','flex-justify-content','button-hover',{'active_button':stage.level == item.levelId,}]" @click="(item.levelId = stage.level),filterContent(item.id,stage.level)"  v-for="stage in item.levels" :key="stage.id">
                                    {{stage.name}}
                                </div>
                            </div>
                        </div>
                        <!-- 子顶部导航栏 -->
                        <div class="tool_wrap">
                            <div class="tool">
                                <div :class="{'active_tool':btn.id == item.id}" @click="item.id = btn.id,filterContent(btn.id,Boolean(item.levels.length) ? item.levelId : 0)" v-for="btn in item.chapterList" :key="btn.id">{{btn.title}}</div>
                            </div>
                        </div>
                        <div class="class_wrap" >
                            <div class="item_model"   @click="enterClass(column)" @mouseenter="activeId = column.id" @mouseleave="activeId = -1" v-for="column in item.sections" :key="column.id">
                                <div class="item_content"  :class="[{'hide_item_content':column.hasPermission}]" v-if="column.id == activeId">
                                    <div>
                                        <div class="item_content_title">课程简介</div>
                                        <div class="item_content_text">{{column.target}}</div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="item_bg" :style="`background:url(${column.imageUrl}) 0 0/100% 100% no-repeat`" ></div>
                                    <div class="item_title">
                                        <div  class="item_title_class ellipsis">{{column.title}}</div>
                                        <div class="course">
                                            课程简介：{{column.target}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="show_more" v-if="item.sections.length < item.allCount">
                            <el-divider><i class="el-icon-caret-bottom button-hover" @click="filterContent(item.id,Boolean(item.levels.length) ? item.levelId : 0,1)">&nbsp;点击查看更多</i></el-divider>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import bus from '../../common/bus';
import { cloudList, detailList, menu } from '../../../utils/api';

export default {
    data() {
        return {
            sideNavVisible:false,
            navList:[{
                menuId:1,
                menuIcon:'icon-qingsongyuxi',
                title:'前置课程',
                navItem:[{
                    name:'python语法基础',
                    idName:'pythonClass'
                }]
            },{
                menuId:2,
                menuIcon:'icon-jichu',
                title:'基础课程',
                navItem: [{
                    name: 'python语法基础',
                    idName: 'pythonClass'
                }]
            },{
                menuId:3,
                menuIcon:'icon-mokuai',
                title:'模块课程',
                navItem: [{
                    name: 'python语法基础',
                    idName: 'pythonClass'
                }]
            },{
                menuId:4,
                menuIcon:'icon-jiaochabiao',
                title:'交叉课程',
                navItem: [{
                    name: 'python语法基础',
                    idName: 'pythonClass'
                }]
            }],
            stageList:[{
                id:1,
                name:'初阶',
                isClick:true
            },{
                id:2,
                name:'中阶',
                isClick:true
            },{
                id:3,
                name:'高阶',
                isClick:true
            },],
            modelContent:[],
            modelId:this.$route.query.modelId,
            activeId:'',
        }
    },
    mounted(){
        this.getDataList()
    },
    methods:{
        //开启实验环境
        startLab(){
            window.open(`${this.$config.SYSTEM_URL}/hub`)
        },

        //基于子顶部导航栏筛选该模块内容
        filterContent(id,stageId,isShowMore = 0){
            detailList({
                courseId:id,
                level:stageId,
                allRequire:isShowMore
            }).then(res => {
               this.modelContent.forEach(item => {
                    if(item.id == id){
                        item.allCount = res.data.allCount
                        item.sections = res.data.list
                    }})
            }).catch(err => {})
        },

        //基于锚点，进行内容定位
        goAnchor(id){
            this.sideNavVisible = false
            let box = document.querySelector('#'+id).offsetTop + 400
            bus.$emit('changeScroll',box)
        },

        //进入课程
        enterClass(item){
            if(item.chapterNum == 0) {
                this.$message.error('当前系列尚未开放,敬请期待！！')
                return
            }
            if(item.hasPermission) return this.$message.error('教师暂未公开此课程')
            let toLink = item.jupyterLink.replace('用户名',this.$store.state.userName)
            window.open(toLink)
        },

        //获取实验室课程列表
        getDataList(){
            cloudList({ type: this.modelId }).then(res => {
                this.modelContent = res.data;
                this.modelContent.forEach(item => {
                    if (item.chapterList.length) {
                        item.id = item.chapterList[0].id;
                    }
                });
            }).catch(err=>{})
            menu({type:this.modelId}).then(res => {
                this.navList = res.data
                this.navList[0].menuIcon = 'icon-qingsongyuxi'
                this.navList[1].menuIcon = 'icon-jichu'
                this.navList[2].menuIcon = 'icon-mokuai'
                this.navList[3].menuIcon = 'icon-jiaochabiao'
            }).catch(err => {})
        }

    }

}
</script>

<style lang="scss" scoped>
/deep/.el-divider{
    padding-left:5% ;
}
.tool_wrap{
    .tool{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #F1F4FF;
        border-radius: 5px;
        color: #5277F7;
        font-weight: bold;
        font-size: 18px;
        box-sizing: border-box;
        margin: 0px auto 15px 30px ;
        white-space: nowrap;
        display: inline-block;
        .active_tool{
            border: 1px solid #5277F7;
            border-radius: 5px;
            background: white;
        }
        >div{
            padding: 0px 30px;
            display: inline-block;
            text-align: center;
            height: 40px;
            line-height: 40px;
            margin: 10px 30px 10px 10px;
        }
        div:hover{
            cursor: pointer;
            border: 1px solid #5277F7;
            border-radius: 5px;
        }
    }
}
.aside_wrap{
    width: 100%;
    padding: 0px 100px 0px 80px;
    box-sizing: border-box;
    height: 200px;
    text-align: center;
    .jupyter_icon{
        // font-size: 20px;
        margin-bottom: 50px;
        >div{
            font-size: 23px;
            margin-top: 15px;
            font-weight: bold;
            color: #5277F7;
        }
        i{
            font-size: 55px;
            color: #F57C00;
        }
    }
    .jupyter_icon:hover{
        opacity: 0.6;
        cursor: pointer;
    }
    li{

        span{
            font-weight: bold;
            font-size: 20px;
            margin-left: 10px;
        }
        i{
            font-size: 20px;
            font-weight: bold;
            color: #333333;
        }
    }
    /deep/.el-menu--collapse{
        width: 100%;
    }
    /deep/.el-menu{
        border-right: 0px;
    }
    // .menu_one{
    //     width: 150px;
    // }
    // background: red;
}
#box{
    position: relative;
}
.model_wrap{
    box-sizing: border-box;
    // padding: 30px 120px 30px 360px;
    .model_wrap_item{
        margin-bottom: 30px;
        .show_more{
            width: 100%;
            height: 60px;
            box-sizing: border-box;
            padding-right: 15%;
            overflow: hidden;
            .el-icon-caret-bottom{
                font-size: 18px;
            }
        }
    }
    .model_title{
        color: #5277F7;
        font-size: 23px;
        height: 25px;
        align-items: center;
        margin-bottom: 15px;
        >div{
            white-space:nowrap;
        }
        /deep/.el-divider--vertical{
            width: 5px;
            background-color: #5277F7;
            height: 25px;
        }
    }
    .stage_button_wrap{
        margin-left: 30px;
        .stage_button{
            height: 30px;
            width: 60px;
            border-radius: 6px;
            background: #F1F4FF;
            font-size: 15px;
            margin-right: 10px;
        }
        .active_button{
            background: #5278F7;
            color: white;
        }
        .disbled_button{
            background: #F3F3F3;
            color: #CACACA;
        }
    }
    .class_wrap{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        .item_model:hover{
            cursor: pointer;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 3px 10px rgba(132, 151, 212, 0.9)
        }
        .item_model{
            width: 300px;
            height: 240px;
            margin: 0px 25px 30px 25px;
            .item_content{
                height: 240px;
                overflow: hidden;
                background: rgba(82, 120, 247, 1);
                color: white;
                padding: 25px 36px 10px 36px;
                box-sizing: border-box;
                .item_content_title{
                    font-size: 20px;
                    font-weight: bold;
                    line-height: 2;
                }
                .item_content_text{
                    font-size: 16px;
                    text-align: justify;
                    line-height: 1.5;
                }
            }
            .hide_item_content{
                background: #999999;
            }
            .item_bg{
                height: 150px;
                width: 100%;
                background: url('../../../assets/img/cloudLab.png') 0 0/100% 100% no-repeat;
                border-radius: 5px 5px 0px 0px;
                overflow: hidden;

            }
            .item_title{
                height: 90px;
                width: 100%;
                box-sizing: border-box;
                padding: 15px 24px;
                box-shadow: 0px 3px 10px rgba(159, 181, 255, 0.24);
                color: #333;
                .item_title_class{
                    height: 35px;
                    line-height: 35px;
                    font-size: 18px;
                    font-family: PingFang SC;
                    font-weight: bold;
                }
                .course{
                    height: 30px;
                    line-height: 30px;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    white-space:nowrap;
                    font-size: 16px;
                }
            }
        }
    }
}
.last_read{
    height: 80px;
    line-height: 80px;
    box-sizing: border-box;
    padding: 0px 100px;
}
.banner_wrap{
    height: 440px;
    width: 100%;
    box-sizing: border-box;
    padding: 100px 25%;
    // color: white;
    text-align: center;
    letter-spacing: 1px;
    .banner_title{
        height: 80px;
        font-size: 45px;
        line-height: 80px;
        font-weight: 400;
        color: #333;
        span{
            padding-bottom: 10px;
            border-bottom: 5px solid #5277F7;
        }

    }
    .banner_text{
        text-align: center;
        margin-top: 50px;
        font-size: 18px;
        // font-weight: bold;
        line-height: 1.7;
    }
}
.cloudLabDetail_wrap{
    background: white;
    position: relative;
    .banner_wrap_one{
        background:url('../../../assets/img/lab_one.png' ) 0 0/100% 100% no-repeat
    }
    .banner_wrap_two{
        background:url('../../../assets/img/lab_two.png' )0 0/100% 100% no-repeat
    }
}

</style>
